
<template>

    <div id="toolbar">

        <div class="title-wrapper" v-if=" isAuth ">

            <font-awesome-icon v-if=" [ 'order-tab' ].includes( previousRoute.name ) && editingItem " class="back-button" icon="arrow-left" @click=" backToTab() "/>
            <font-awesome-icon v-else-if=" [ 'order-success', 'payment', 'view-order', 'view-card', 'view-msg', 'order-tab', 'merchant-location' ].includes( currentRoute.name ) && currentLocation != null" class="back-button" icon="arrow-left" @click=" genericReturn() "/>
            <font-awesome-icon v-else-if=" backButton || editingItem " class="back-button" icon="arrow-left" @click=" chooseCategory( parentCategoryId ) "/>
            <font-awesome-icon v-else-if=" [ 'order-history' ].includes( currentRoute.name ) " class="back-button" icon="sync-alt" @click=" refreshPage( currentRoute.name ) "/>

            <h3 class="page-title" style="margin: 0" v-if=" pageTitle != null">{{ pageTitle }}</h3>
            <font-awesome-icon v-if=" [ 'merchant-location' ].includes( currentRoute.name ) " class="home-button" icon="sync-alt" @click=" getLocations() "/>
            <font-awesome-icon v-else-if=" allLocations != null " class="home-button" icon="map-marker-alt" @click=" locationPage() "/>
        </div>
    </div>
</template>

<script>

    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'tool-bar',
        components: {

            FontAwesomeIcon
        },
        methods: {

            ...mapActions({

                signOut        : 'auth/signout',
                chooseCategory : 'orderMenu/chooseCategory',
                getLocations   : 'merchant/getLocations'
            }),
            locationPage(){

                if( this.editingItem ) this.$store.dispatch( 'orderMenu/clearState', true );
                this.$router.replace( { name: 'merchant-location' } );
            },
            backToTab(){

                this.$store.dispatch( 'orderMenu/clearState', true );
                this.$router.replace( { name: 'order-tab' } );
            },
            genericReturn(){

                if( [ 'order-success', 'payment', 'view-order', 'view-card', 'view-msg' ].includes( this.currentRoute.name ) ){

                    switch( this.currentRoute.name ){

                        case 'view-order':

                            this.$router.push( { name: 'order-history' } );
                            break;
                        case 'view-msg':

                            this.$router.push( { name: 'in-app-msg' } );
                            break;
                        case 'view-card':

                            this.$router.push( { name: 'manage-cards' } );
                            break;
                        case 'payment':

                            this.$router.push( { name: 'order-tab' } );
                            break;
                        case 'order-success':

                            this.$router.push( { name: 'home' } );
                            break;
                    }
                } else this.$router.push( { name: [ "", null ].includes( this.previousRoute.name ) ? 'home' : this.previousRoute.name } );
            },
            refreshPage( routeName ){

                switch( routeName ){

                    case 'order-history':

                        this.$store.dispatch( 'orders/clearState' );
                        this.$store.dispatch( 'orders/getOrders' );
                        break;
                }
            }
        },
        computed: {

            ...mapGetters({

                currentMenuView  : 'orderMenu/currentMenuView',
                currentCategory  : 'orderMenu/currentCategory',
                parentCategoryId : 'orderMenu/parentCategoryId',
                currentItem      : 'orderMenu/currentItem',
                editingItem      : 'orderMenu/editingItem',
                allLocations     : 'merchant/allLocations',
                currentLocation  : 'merchant/currentLocation',
                isAuth           : 'auth/isAuth',
                currentRoute     : 'currentRoute',
                previousRoute    : 'previousRoute',
                routes           : 'nav/routes'
            }),
            pageTitle(){

                if( this.currentRoute.name == 'order-tab' ) {

                    return 'Your Cart';
                } else if( this.currentRoute.name == 'merchant-location' ){

                    return 'Select Location';
                } else if( this.currentRoute.name == 'payment' ){

                    return 'Payment Details';
                } else if( this.currentItem != null ) {

                    return this.currentItem.QuickItem.name;
                } else if( this.currentCategory != null ) {

                    return this.currentCategory.QuickCategory.name;
                } else if( this.currentRoute.name == 'order-menu' && this.currentCategory === null && this.currentMenuView == 'Category' ){

                    return 'Express Orders';
                } else if( this.currentRoute.name == 'home' ) {

                    return '';
                } else {

                    const relevantRoute = this.routes.filter( route => {

                        if( route.name == this.currentRoute.name ) return route;
                    });
                    return ( relevantRoute[ 0 ] != null ) ? relevantRoute[ 0 ].title : '';
                }
            },
            backButton(){

                return ( this.currentCategory == null ) ? false : true;
            }
        }
    }

</script>

<style scoped>

    #toolbar > div {

        cursor: pointer;
    }

    #toolbar {

        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        width: 100%;
        height: 60px;
    }

    .title-wrapper {

        color: white;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back-button {

        position: absolute;
        left: 15px;
    }
    .page-title {

        text-align: center;
    }
    .home-button {

        position: absolute;
        right: 15px;
    }


    @media screen and ( min-width: 420px ) {

        #toolbar{

            /* display: none !important; */
        }
    }

</style>